import _ from 'lodash'
import { generateUUID } from '@ps/utils/game'
import {
  getVpAstActionConfig,
  mergeResponseEventParamFormConfig,
} from '@ps/bridge/qc/vp/config'
import { VpMethods } from './config'
import i18n from '@ps/lang'
import { scripts } from '../scripts'
import { DrawLineType } from '@ps/workbench/undo-redo/module/draw-line'

export const vpAstAction = getVpAstActionConfig()

/**
 * 获取响应事件 label
 */
function getResponseEventLabel(action) {
  if (vpAstAction[action.method]) {
    return vpAstAction[action.method].label || action.label
  }
  return action.label
}

function getResponseEventCategory(action) {
  if (vpAstAction[action.method]) {
    return vpAstAction[action.method].category || action.category
  }
  return action.category
}

/**
 * 响应事件参数排序
 */
function sortResponseEventParam({ data, method }) {
  const utils = {
    [VpMethods.vpPlayVideo]: ['loop', 'loopNumber', 'playEndFrame'],
    [VpMethods.vpPlayMC]: ['loop', 'playTime', 'pingpong', 'hideWhenFinished'],
  }
  // 对象的顺序是根据属性添加的顺序决定的
  if (utils[method]) {
    const newData = {}
    _.each(utils[method], (key) => {
      if (data[key]) {
        newData[key] = data[key]
      }
    })
    return newData
  }
  return data
}

// vpBasicAction: 节点内置的vp方法
// vpAction: 节点上挂载的脚本扩展的vp方法，即非内置的vp方法
// VPBasicActionBack: 向攀加的，看vpEditor.js代码是用来兼容自研素材的，和vpBasicAction是类似的概念
// vpActionConfig: 所有vp方法的配置，用于配置参数的类型和初始值初始方法

/**
 * @description 根据 节点 获取所有包含的 Action
 */
export function getVpActionsFromNode(node, { hasBgm }) {
  if (!node) return []
  const actionList = []
  const uniqueActions = {}
  const scriptHasVpAction = node.scripts.filter((s) => s.vpAction)

  scriptHasVpAction.forEach((script) => {
    const vpAction = script.vpAction
    for (const i in vpAction) {
      // 连线组件vpAction根据类型过滤
      if (script.class === scripts.drawLine.name) {
        if (
          script.isConnectLine &&
          vpAction[i].type === DrawLineType.FREE_LINE
        ) {
          // eslint-disable-next-line no-continue
          continue
        }
        if (
          script.isFreeLine &&
          vpAction[i].type === DrawLineType.CONNECT_LINE
        ) {
          // eslint-disable-next-line no-continue
          continue
        }
      }
      // 不同script的重名method去重显示
      if (!uniqueActions.hasOwnProperty(vpAction[i].method)) {
        const id = generateUUID()
        const scriptClass =
          script.class.indexOf('qc.Tween') === 0 ? 'qc.Tween' : script.class
        const currentVpAction = _.cloneDeep(vpAction[i])
        const scriptVpActionConfig = script.vpActionConfig[i]
        const method = currentVpAction.method
        let actionTip = null
        if (vpAstAction[method]) {
          actionTip =
            vpAstAction[method] && vpAstAction[method].actionTip
              ? i18n.t(vpAstAction[method].actionTip)
              : ''
        }
        actionList.push({
          id,
          script: scriptClass,
          label: getResponseEventLabel(currentVpAction),
          method,
          param: scriptVpActionConfig
            ? {
                ...scriptVpActionConfig,
                properties: sortResponseEventParam({
                  data: mergeResponseEventParamFormConfig({
                    formConfig: scriptVpActionConfig.properties,
                    method,
                  }),
                  method,
                }),
              }
            : {},
          category: getResponseEventCategory(currentVpAction),
          target: currentVpAction.target,
          paramLabel: currentVpAction.paramLabel,
          paramParseFunc: currentVpAction.paramParseFunc,
          actionTip: actionTip,
        })
      }
      uniqueActions[vpAction[i].method] = true
    }
  })

  const builtInAction = node.VPBasicActionBack || node.VPBasicAction || []
  // 没有背景音乐时去掉背景音乐的相关响应动作
  if (!hasBgm) {
    delete builtInAction.vpAction[VpMethods.vpPlayBgm]
    delete builtInAction.vpAction[VpMethods.vpReplayBgm]
    delete builtInAction.vpAction[VpMethods.vpResumeBgm]
    delete builtInAction.vpAction[VpMethods.vpStopBgm]
  }
  for (const i in builtInAction.vpAction) {
    const id = generateUUID()
    const vpAction = builtInAction.vpAction[i]
    const vpActionConfig = builtInAction.vpActionConfig[i]
    const method = vpAction.method
    actionList.push({
      id,
      script: '',
      label: getResponseEventLabel(vpAction),
      method,
      param: vpActionConfig
        ? {
            ...vpActionConfig,
            properties: sortResponseEventParam({
              data: mergeResponseEventParamFormConfig({
                formConfig: vpActionConfig.properties,
                method,
              }),
              method,
            }),
          }
        : {},
      category: getResponseEventCategory(vpAction),
      target: vpAction.target,
      paramLabel: vpAction.paramLabel,
      paramParseFunc: vpAction.paramParseFunc,
    })
  }
  return actionList
}
